<template>
  <div id="hrmanage">
    <a-row a-row class="row" justify="space-between" align="middle">
      <a-col span="7">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">推荐时间</a-col>
          <a-col span="18">
            <a-form-item>
              <a-range-picker
                style="display:block"
                format="YYYY-MM-DD"
                v-model="params.time"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="7">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">负责BD</a-col>
          <a-col span="18">
            <a-form-item>
              <a-select
                allowClear
                v-model="params.ie_uid"
                showSearch
                placeholder="请填写负责BD"
                style="width: 100%"
                :defaultActiveFirstOption="false"
                :showArrow="false"
                :filterOption="false"
                @search="handleSearchBD"
                :notFoundContent="null"
              >
                <a-select-option
                  v-for="(item, index) in databd"
                  :key="index"
                  :value="item.uid"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="7">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">公司名</a-col>
          <a-col span="18">
            <a-form-item>
              <a-select
                allowClear
                v-model="params.hr_company_id"
                showSearch
                placeholder="请填写所属公司"
                style="width: 100%"
                :defaultActiveFirstOption="false"
                :showArrow="false"
                :filterOption="false"
                @search="handleSearch"
                :notFoundContent="null"
              >
                <a-select-option
                  v-for="(item, index) in companyData"
                  :key="index"
                  :value="item.id"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row style="padding-top:20px;" justify="space-between">
      <a-col span="7">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">HR姓名</a-col>
          <a-col span="18">
            <a-form-item>
              <a-input
                style="display:block"
                placeholder="请输入关键字"
                v-model="params.hr_name"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="7">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">HR手机号</a-col>
          <a-col span="18">
            <a-form-item>
              <a-input
                style="display:block"
                placeholder="请输入关键字"
                v-model="params.hr_mobile"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <div class="order-page-type">
      <a-button size="large" class="screen" type="primary" @click="slectList"
        >筛选</a-button
      >
      <a-button size="large" class="clear-screen" @click="clearSelect"
        >清空筛选条件</a-button
      >
      <a-button
        size="large"
        class="screen left"
        type="primary"
        @click="operateStaff()"
        v-if="isGranted('company_manager.hr_list.btn_add_hr')"
        >添加HR</a-button
      >
    </div>
    <a-divider></a-divider>
    <a-row :gutter="80" align="top">
      <a-col>
        <a-spin :spinning="loading" size="large">
          <a-table
            @change="getListData"
            :pagination="pagination"
            :dataSource="listData"
            :columns="columns"
            rowKey="id"
            :customRow="click"
          >
            <template slot="action" slot-scope="text, record">
              <a-row type="flex" :gutter="10" justify="start">
                <a-col
                  v-if="isGranted('company_manager.hr_list.btn_list_edit')"
                >
                  <a @click.stop="operateStaff(record)">编辑</a>
                </a-col>
              </a-row>
            </template>
          </a-table>
        </a-spin>
      </a-col>
    </a-row>
    <ShowMessage
      ref="showModal"
      :allDetail="allDetail"
      :getListData="getListData"
      :callback="operateStaff"
      :record="clickRow"
    ></ShowMessage>
    <EditMessage
      ref="editModal"
      :record="record"
      :getListData="getListData"
    ></EditMessage>
  </div>
</template>

<script>
import ShowMessage from "./showMessage";
import EditMessage from "./editMessage";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
import debounce from "lodash/debounce";
import moment from "moment";
export default {
  name: "HrManage",
  extends: baseComponentVue,
  data() {
    this.handleSearch = debounce(this.handleSearch, 800);
    this.handleSearchBD = debounce(this.handleSearchBD, 800);
    return {
      companyData: [],
      databd: [],
      loading: false,
      listData: [],
      columns: undefined,
      allDetail: {},
      record: {},
      clickRow: {},
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      params: {
        time: [],
        hr_company_id: undefined,
        hr_name: undefined,
        hr_mobile: undefined,
        ie_uid: undefined
      }
    };
  },
  components: { ShowMessage, EditMessage },
  computed: {},
  created() {
    if (this.$route.query.companyId) {
      this.params.hr_company_id = this.$route.query.companyId;
      this.companyData = [
        { id: this.$route.query.companyId, name: this.$route.query.companyName }
      ];
    }
    this.setColumns();
  },
  mounted() {
    this.getListData();
  },
  methods: {
    handleSearchBD(value) {
      if (!value) return;
      Api.hrlist.searchBD({ name: value }).then(response => {
        this.databd = response;
      });
    },
    handleSearch(value) {
      if (!value) return;
      Api.hrlist.searchCompany({ company_name: value }).then(response => {
        this.companyData = response;
      });
    },
    async getListData(pagination, filters, sorter) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      }
      let params = {
        created_start:
          this.params.time[0] && this.params.time[0].format("YYYY-MM-DD"),
        created_end:
          this.params.time[1] && this.params.time[1].format("YYYY-MM-DD"),
        hr_company_id: this.params.hr_company_id,
        hr_name: this.params.hr_name,
        hr_mobile: this.params.hr_mobile,
        ie_uid: this.params.ie_uid,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      try {
        let response = await Api.hrlist.getList(params);
        this.listData = response.list;
        this.pagination.total = +response.total;
      } catch (e) {}
      this.loading = false;
    },
    setColumns() {
      this.columns = [
        {
          title: "姓名",
          dataIndex: "hr_name"
        },
        {
          title: "手机号",
          dataIndex: "hr_mobile"
        },
        {
          title: "所属公司",
          dataIndex: "company_name"
        },
        {
          title: "职位title",
          dataIndex: "hr_title"
        },
        {
          title: "建档人",
          dataIndex: "ie_name"
        },
        {
          title: "创建时间",
          dataIndex: "created_at"
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ];
    },
    slectList() {
      this.getListData();
    },
    clearSelect() {
      this.params = {
        time: [],
        hr_company_id: undefined,
        hr_name: undefined,
        hr_mobile: undefined,
        ie_uid: undefined
      };
    },
    //点击行事件
    click(record, index) {
      return {
        on: {
          click: () => {
            console.log(record, index);
            let { showModal } = this.$refs;
            this.hr_id = record.id;
            this.getDetail(this.hr_id);
            this.clickRow = record;
            showModal.show();
          }
        }
      };
    },
    async getDetail(item) {
      let response = await Api.hrlist.getDetail({ hr_id: item });
      console.log(response);
      this.allDetail = response;
    },
    editStaff(info) {
      this.operateStaff(info);
    },
    operateStaff(record) {
      console.log(record);
      let { editModal } = this.$refs;
      editModal.type = "add";
      if (record) {
        this.record = record;
        editModal.type = "edit";
      }
      editModal.show();
    }
  }
};
</script>

<style lang="scss">
#hrmanage {
  .ant-form-item-control {
    line-height: 24px;
  }
  .ant-table-row {
    cursor: pointer !important;
  }
  .order-page-type {
    margin-top: 20px;
    .clear-screen {
      height: 40px;
      border-radius: 4px;
      color: #5ec9ff;
      border: 1px solid #5ec9ff;
      margin-right: 10px;
    }
    .screen {
      color: #ffffff;
      height: 40px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .left {
      position: absolute;
      right: 20px;
    }
  }
}
</style>
